import { render, staticRenderFns } from "./SettingsCardMailTemplatesBulkOfferRequest.vue?vue&type=template&id=5816627a"
import script from "./SettingsCardMailTemplatesBulkOfferRequest.vue?vue&type=script&lang=ts"
export * from "./SettingsCardMailTemplatesBulkOfferRequest.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports